import React from "react";
// import { PlacesTreeView } from "../../pages/Places/PlacesTreeView";
import { ScopingOrgsTreeView } from "../../pages/org/ScopingOrgsTreeView";
import { Box, Typography } from "@common-ui/ui";
import { ListViewCustomer } from "./ListViewCustomer";

export const ListView = ({ data, setSelection, selected }) => {
  if (data?.length) {
    if (data[0]?.id) {
      // organization
      return (
        <>
          <Box
            component="main"
            sx={{
              width: "100%",
              maxWidth: "100%",
              height: 400,
              bgcolor: "background.paper",
            }}
          >
            <Typography variant="h6">Internal Clients</Typography>
            <ScopingOrgsTreeView
              orgs={data}
              selected={selected}
              setSelection={setSelection}
            />
          </Box>
        </>
      );
    } else {
      // client
      return (
        <ListViewCustomer
          data={data}
          setSelection={setSelection}
          selected={selected}
        />
      );
    }
  } else {
    return "No Data";
  }
};
